import api from '@/api';
import * as types from '@/store/types';
import eventHub from '@/eventHub';

const state = {
    errors: [],
};


const getters = {
    password: state => state,
};


const actions = {

    sendResetPasswordLink ({ dispatch, commit }, email) {
        return dispatch('clearData')
            .then(() => api.password.sendResetPasswordLink(email))
            .catch((error) => {
                commit(types.SEND_RESET_PASSWORD_LINK_ERROR, {
                    error,
                });
            });
    },

    setNewPassword ({ dispatch, commit }, data) {
        return dispatch('clearData')
            .then(() => api.password.setNewPassword(data))
            .catch((error) => {
                commit(types.SET_NEW_PASSWORD_ERROR, {
                    error,
                });
            });
    },

};


const mutations = {

    [types.SEND_RESET_PASSWORD_LINK_ERROR] (state, { error }) {
        Object.assign(state, {
            errors: error,
        });

        eventHub.$emit('sendResetPasswordLink:error');
    },

    [types.SET_NEW_PASSWORD_ERROR] (state, { error }) {
        Object.assign(state, {
            errors: error,
        });

        eventHub.$emit(error.response.status === 422 ? 'setNewPassword:emailError' : 'setNewPassword:tokenError');
    },
    
};

export default {
    state,
    getters,
    actions,
    mutations,
};
